export default __webpack_public_path__ + "static/media/promo_02.bc70db36.jpg";